import React from 'react'
import { Box } from '@mui/material'
import BorkuMark from '../../assets/img/borkuIcon.png'

/**
 * The Borku lockup: the "B" mark followed by the "orku" badge.
 *
 * The mark is a transparent, 800px-square asset so it stays crisp on any
 * display density; to swap in a different artwork, replace
 * `src/assets/img/borku-mark.png` — nothing here needs to change.
 */
function BrandLogo({ size = 120 }) {
  return (
    <Box
      component="a"
      href="#/"
      aria-label="Borku"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        textDecoration: 'none',
        minWidth: 0
      }}>
      <Box
        component="img"
        src={BorkuMark}
        alt=""
        sx={{
          width: size,
          height: size,
          objectFit: 'contain',
          flexShrink: 0,
          display: 'block'
        }}
      />
    </Box>
  )
}

export default BrandLogo
